import { AuthApi } from '../auth/authApi';
import { Singleton } from '@/decorators';
import type { GetReleaseRequestDTO, GetReleaseResponseDTO } from './DTOs';
import type { Result } from '@/types/result.interface';
import type { AppError } from '@/types/errors.interface';
import { wrapHttpCall } from '../utils/apiResultMapper';

/**
 * Release API (Framework Agnostic)
 * 
 * Handles release information retrieval for application forms.
 */
@Singleton
export class ReleaseApi extends AuthApi {
  constructor() {
    super();
  }

  async getRelease(body: GetReleaseRequestDTO): Promise<Result<GetReleaseResponseDTO, AppError>> {
    return wrapHttpCall(() => this.api.get<GetReleaseResponseDTO>(
      `/ApplicationForm/${body.applicationId}/release`,
    ));
  }
}
